import { authService } from '../auth/authService.js';

export function renderProfileMenu() {
    const container = document.getElementById('user-menu-container');
    if (!container) return;

    const user = authService.currentUser;
    const role = authService.userRole;
    const isAdmin = role === 'admin';
    const email = user ? user.email : '';
    const displayName = user ? (user.displayName || email.split('@')[0]) : 'User';
    const initial = displayName.charAt(0).toUpperCase();

    // Clear and build profile menu dynamically to ensure monolingual UI and absolute policy consistency
    container.innerHTML = `
        <button id="btn-toggle-user-menu" class="flex items-center gap-2 hover:bg-slate-50 p-1.5 rounded-xl transition border border-slate-200 focus:outline-none">
            <div class="w-8 h-8 rounded-full bg-gradient-to-tr from-indigo-500 to-purple-500 text-white flex items-center justify-center font-bold shadow-sm" id="user-avatar">${initial}</div>
            <span id="user-info" class="text-sm font-bold text-slate-700">${displayName}</span>
        </button>
        <div id="user-dropdown" class="hidden absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-50 transition-all duration-200 opacity-0 scale-95 origin-top-right">
            <div class="px-4 py-3 border-b border-gray-100 mb-2">
                <p class="text-[10px] font-bold text-indigo-500 uppercase tracking-wider mb-1">현재 권한</p>
                <p id="user-role-display" class="text-sm font-extrabold text-slate-800 flex items-center gap-1">
                    ${isAdmin ? '👑 시스템 관리자' : '👤 일반 사용자'}
                </p>
            </div>
            <button id="btn-open-settings" class="w-full text-left px-4 py-2.5 text-sm font-bold text-slate-700 hover:bg-slate-50 hover:text-indigo-600 transition flex items-center gap-2">⚙️ 설정</button>
            <button id="btn-open-admin" class="w-full text-left px-4 py-2.5 text-sm font-bold text-slate-700 hover:bg-slate-50 hover:text-indigo-600 transition flex items-center gap-2 ${isAdmin ? '' : 'hidden'}">🛡️ 시스템 관리자</button>
            <div class="border-t border-gray-100 my-2"></div>
            <button id="btn-logout" class="w-full text-left px-4 py-2.5 text-sm font-bold text-rose-600 hover:bg-rose-50 transition flex items-center gap-2">🚪 로그아웃</button>
        </div>
    `;

    // Dropdown toggling
    const btnToggle = container.querySelector('#btn-toggle-user-menu');
    const dropdown = container.querySelector('#user-dropdown');

    const toggleDropdown = (show) => {
        if (show) {
            dropdown.classList.remove('hidden');
            setTimeout(() => {
                dropdown.classList.remove('opacity-0', 'scale-95');
                dropdown.classList.add('opacity-100', 'scale-100');
            }, 10);
        } else {
            dropdown.classList.remove('opacity-100', 'scale-100');
            dropdown.classList.add('opacity-0', 'scale-95');
            setTimeout(() => dropdown.classList.add('hidden'), 200);
        }
    };

    btnToggle?.addEventListener('click', (e) => {
        e.stopPropagation();
        const isHidden = dropdown.classList.contains('hidden');
        toggleDropdown(isHidden);
    });

    document.addEventListener('click', () => {
        if (!dropdown.classList.contains('hidden')) {
            toggleDropdown(false);
        }
    });

    // Sub-menu button actions
    container.querySelector('#btn-open-settings')?.addEventListener('click', () => {
        window.location.href = 'admin.html?mode=settings';
    });

    container.querySelector('#btn-open-admin')?.addEventListener('click', () => {
        window.location.href = 'admin.html?mode=admin';
    });

    container.querySelector('#btn-logout')?.addEventListener('click', async () => {
        await authService.logout();
    });
}
